import React from "react";
import BlogStyle from "../../../assets/stylesheets/blog/BlogDetail.module.css";
import SignupForm from "../../../layouts/SignupForm";
import FooterStyle from "../../../assets/stylesheets/Footer.module.css";
import AppStyle from "../../../assets/stylesheets/App.module.css";
import WPPostsPage from "../blog-categories/WPPostsPage";  
import { useNavigate } from "react-router-dom";
import slugify from "slugify";

// Local blog images
import MaerketMain from "../../../assets/img/blog/marketMain.webp";
import Bradford from "../../../assets/img/blog/Bradford.webp";
import EloraChristmas from "../../../assets/img/blog/eloraChristmas.webp";
import HollyJolly from "../../../assets/img/blog/hollyJolly.webp";
import TorontoDistillery from "../../../assets/img/blog/torontoDistillery.webp";
import UxbridgeFarmers from "../../../assets/img/blog/uxbridgeFarmers.webp";

// API: farms
import { getFarmById } from "../../../api/farm-service/farmService";
// cover image API
import { getCoverImage } from "../../../api/farm-service/imageService";

// Manual farm data with name, location, date, time
const FARMS_DATA = [
  {
    id: 1,
    name: 'Elora Christmas Market',
    location: 'Elora Mews, 45 West Mill Street,  Elora, Ontario',
    date: 'Nov 14, 2025 & Wed–Sun until Christmas',
    time: '10:00 am – 6:00 pm',
    description: ' A touch of Europe in the heart of Ontario 🇨🇦 — artisan stalls, live music, and cozy treats for all ages.',
    img: EloraChristmas,
    url: ''
  },
  {
    id: 2,
    name: 'Toronto Distillery District Christmas Market',
    location: 'Distillery District, 55 Mill St, Toronto, Ontario',
    date: 'Nov 15 – Dec 24, 2025',
    time: '11:00 am – 9:00 pm',
    description: 'Cobblestone streets, twinkling lights, and hot cocoa — Toronto’s iconic holiday hotspot! ',
    img: TorontoDistillery,
    url: ''
  },
  {
    id: 3,
    name: 'Uxbridge Farmers’ Christmas Market',
    location: '20 Toronto St S, Uxbridge, Ontario',
    date: 'Nov 14 – Dec 21, 2025',
    time: '10:00 am – 5:00 pm',
    description: 'Local makers, seasonal treats, wagon rides, and festive fun for the whole family ',
    img: UxbridgeFarmers,
    url: ''
  },
  {
    id: 4,
    name: 'Bradford Greenhouse Holiday Market',
    location: 'Bradford Greenhouses Garden Gallery, 4346 Hwy 90, Springwater, Ontario',
    date: 'Nov 8 – Dec 7, 2025 (Sat & Sun)',
    time: 'Sat 10:00 am – 5:00 pm, Sun 11:00 am – 4:00 pm',
    description: 'Step into a greenhouse wonderland full of holiday decorations, lights, and cozy seasonal vibes ',
    img: Bradford,
    url: ''
  },
  {
    id: 5,
    name: 'Holly Jolly Holiday Market',
    location: 'Covent Garden Market, 130 King St W, London, Ontario',
    date: 'Dec 5 – 21, 2025',
    time: '11:00 am – 6:00 pm',
    description: 'A cheerful holiday pop-up where every corner jingles with joy — perfect for festive family fun!',
    img: HollyJolly,
    url: ''
  }
];

// Reusable Best-of component (renders the list once)
function BestOfList({ className = "" }) {
  return (
    <div className={`${BlogStyle["card-left"]} ${className}`}>
      <div className={BlogStyle["car-title"]}>All our Best of lists</div>
      <div className={BlogStyle["related-subtitle"]}>Christmas</div>
      <ul className={BlogStyle["related-list"]}>
        <li><a href="https://farmciti.com/farm/233/thunderbird-farm">Thunderbird Farm</a></li>
        <li><a href="https://farmciti.com/farm/4/kustermans-adventure-farm">Kustermans Adventure Farm</a></li>
        <li><a href="https://farmciti.com/farm/181/wayne-gretzky-estates">Wayne Gretzky Estates</a></li>
        <li><a href="https://farmciti.com/farm/129/peller-estates-winery-and-restaurant">Peller Estates Winery & Restaurant</a></li>
        <li><a href="https://farmciti.com/farm/180/trius-winery-and-restaurant">Trius Winery & Restaurant</a></li>
        <li><a href="https://farmciti.com/farm/126/the-hare-wine-co">The Hare Wine Co.</a></li>
        <li><a href="https://farmciti.com/farm/176/ravine-vineyard-estate-winery">Ravine Vineyard Estate Winery</a></li>
        <li><a href="https://farmciti.com/farm/144/closson-chase">Closson Chase</a></li>
        <li><a href="https://farmciti.com/farm/170/norman-hardie-winery-and-vineyard">Norman Hardie Winery</a></li>
        <li><a href="https://farmciti.com/farm/62/niemi-family-farm">Niemi Family Farm</a></li>
      </ul>
    </div>
  );
}

export default function ChristmasMarketsBlogPage() {
  const [showTopAd, setShowTopAd] = React.useState(true);
  const navigate = useNavigate();
  const [expandedCards, setExpandedCards] = React.useState({}); // 카드별 확장 상태

  // Use static farm data instead of API calls
  const [items, setItems] = React.useState(FARMS_DATA);
  const [loadingItems, setLoadingItems] = React.useState(true); // Start with loading state
  const [imgLoaded, setImgLoaded] = React.useState({});
  const markLoaded = (idx) => setImgLoaded((p) => ({ ...p, [idx]: true }));

  const toggleCardExpansion = (cardId) => {
    setExpandedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };

  // Simulate loading for static data
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoadingItems(false);
    }, 1500); // 1.5 second loading simulation
    
    return () => clearTimeout(timer);
  }, []);

  // Skeleton card component for loading state
  const renderSkeletonCard = (idx) => (
    <div key={`skeleton-${idx}`} className={`${BlogStyle["market-card"]} ${BlogStyle["card-skeleton"]}`}>
      <div className={BlogStyle['card-img-container']}>
        <div className={BlogStyle["card-img-skeleton-static"]} style={{ height: '200px' }} />
      </div>
      <div className={BlogStyle["market-card-content"]}>
        <div className={BlogStyle["market-card-header"]}>
          <span className={BlogStyle["badge-number-skeleton"]} style={{ width: '40px', height: '40px', borderRadius: '12px' }} aria-hidden="true" />
          <div className={BlogStyle["card-title-skeleton"]} style={{ width: '70%', height: '24px' }} aria-hidden="true" />
        </div>
        <div className={BlogStyle["market-card-meta"]}>
          <div className={BlogStyle["market-meta-item"]}>
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '16px', height: '16px', borderRadius: '2px' }} />
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '60%', height: '14px' }} />
          </div>
          <div className={BlogStyle["market-meta-item"]}>
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '16px', height: '16px', borderRadius: '2px' }} />
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '80%', height: '14px' }} />
          </div>
          <div className={BlogStyle["market-meta-item"]}>
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '16px', height: '16px', borderRadius: '2px' }} />
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '50%', height: '14px' }} />
          </div>
        </div>
        <div className={BlogStyle["card-desc-skeleton-group"]} aria-hidden="true" style={{ marginTop: 'var(--gap-sm)' }}>
          <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '95%' }} />
          <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '88%' }} />
          <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '75%' }} />
        </div>
      </div>
    </div>
  );

  return (
    <article className={BlogStyle["page"]}>
      {/* Top banner advertisement under header */}
      {/* {showTopAd && (
        <section className={BlogStyle["top-ad"]} role="complementary" aria-label="Advertisement">
          <button
            type="button"
            className={BlogStyle["top-ad-close"]}
            aria-label="Close advertisement"
            onClick={() => setShowTopAd(false)}
          >
            ×
          </button>
          <img
            className={BlogStyle["top-ad-img"]}
            src="https://images.unsplash.com/photo-1519710164239-da123dc03ef4?q=80&w=1920&auto=format&fit=crop"
            alt="Sponsored banner"
          />
          <div className={BlogStyle["top-ad-overlay"]}>
            <a
              className={BlogStyle["top-ad-btn"]}
              href="https://www.example.com"
              target="_blank"
              rel="noopener sponsored"
            >
              Search homes
            </a>
          </div>
        </section>
      )} */}

      {/* Top meta like blogTO */}
      <div className={BlogStyle["top-meta"]}>
        {/* <span className={BlogStyle["category-name"]}>Best of Winter</span>
        <span className={BlogStyle["sep"]}>•</span>
        <span>FarmCiti Team</span>
        <span className={BlogStyle["sep"]}>•</span>
        <span>Posted today</span> */}
      </div>

      {/* Big title */}
      <h1 className={BlogStyle["title"]}>Best 5 Christmas Markets near Toronto 2025</h1>

      {/* Hero image */}
      <div className={BlogStyle["hero-wrap"]}>
        <img
          className={BlogStyle["hero"]}
          src={MaerketMain}
          alt="Winter farm hero"
        />
      </div>

      {/* Main body under hero with gap, using left sidebar layout */}
      <section className={BlogStyle["content-wrap-left"]}>
        {/* Sidebar on the left */}
        <aside className={`${BlogStyle["sidebar"]} ${BlogStyle["sidebar-left"]}`}>
          {/* <div className={BlogStyle["ad-box"]} role="complementary" aria-label="Advertisement">
            <img className={BlogStyle["ad-media"]} src={AD02} alt="Advertisement" />
          </div> */}

          <div className={BlogStyle["newsletter"]}>
            <div className={FooterStyle["footer-column"]}>
              <SignupForm />
            </div>
          </div>

          <div className={BlogStyle["hr"]} />

          {/* Desktop/Tablet: show in sidebar */}
          <BestOfList className={BlogStyle["bestof-desktop"]} />
        </aside>

        {/* Main content on the right */}
        <main className={BlogStyle["content"]}>
          <p className={BlogStyle["lead"]}>
          Looking for magical holiday experiences this season? From twinkling lights to festive treats, these can’t-miss Christmas markets near Toronto are perfect for making unforgettable family memories. Cozy up, explore artisan stalls, enjoy seasonal fun, and get into the holiday spirit!
          <br/><br/>✨ Save this list for the ultimate guide to the best winter and Christmas markets around the GTA in 2025.
  
          </p>
          
          <div className={BlogStyle["hr"]} />
          {/* Market cards with new design */}
          <div className={BlogStyle["market-grid"]}>
            {loadingItems ? (
              // Show skeleton cards while loading
              Array.from({ length: 8 }, (_, index) => renderSkeletonCard(index))
            ) : (
              // Show actual market cards when loaded
              items.map((item, index) => {
                const isExpanded = expandedCards[item.id];
                return (
                  <div key={`market-${item.id}`} className={BlogStyle["market-card"]}>
                    <div className={BlogStyle['card-img-container']}>
                      <img
                        className={BlogStyle["market-card-image"]}
                        src={item.img || "/assets-placeholder/no-image.png"}
                        alt={item.name || `Market ${index + 1}`}
                        loading="lazy"
                        decoding="async"
                        onLoad={() => setImgLoaded(prev => ({ ...prev, [index]: true }))}
                        onError={(e) => { e.currentTarget.src = '/assets-placeholder/no-image.png'; setImgLoaded(prev => ({ ...prev, [index]: true })); }}
                      />
                      {!imgLoaded[index] && <div className={BlogStyle["card-img-skeleton"]} />}
                    </div>
                    
                    <div className={BlogStyle["market-card-content"]}>
                      <div className={BlogStyle["market-card-header"]}>
                        <span className={BlogStyle["market-badge-number"]}>{index + 1}</span>
                        <h2 className={BlogStyle["market-card-title"]}>{item.name}</h2>
                      </div>
                      
                      <div className={BlogStyle["market-card-meta"]}>
                        <div className={BlogStyle["market-meta-item"]}>
                          <svg className={BlogStyle["market-meta-icon"]} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          <span className={BlogStyle["market-meta-location"]}>{item.location}</span>
                        </div>
                        
                        <div className={BlogStyle["market-meta-item"]}>
                          <svg className={BlogStyle["market-meta-icon"]} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          <span className={BlogStyle["market-meta-date"]}>{item.date}</span>
                        </div>
                        
                        <div className={BlogStyle["market-meta-item"]}>
                          <svg className={BlogStyle["market-meta-icon"]} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <span className={BlogStyle["market-meta-time"]}>{item.time}</span>
                        </div>
                      </div>
                      
                      {item.description && (
                        <>
                          <div className={BlogStyle["market-description-wrapper"]}>
                            <p className={`${BlogStyle["market-card-description"]} ${isExpanded ? BlogStyle["market-description-expanded"] : ""}`}>
                              {item.description}
                            </p>
                          </div>
                          <button 
                            className={BlogStyle["market-expand-btn"]}
                            onClick={() => toggleCardExpansion(item.id)}
                            aria-label={isExpanded ? "접기" : "더보기"}
                          >
                            <svg 
                              className={`${BlogStyle["market-expand-icon"]} ${isExpanded ? BlogStyle["market-expand-icon-rotated"] : ""}`}
                              fill="none" 
                              stroke="currentColor" 
                              viewBox="0 0 24 24"
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>

        </main>

        {/* Mobile: show below items and above map */}
        <BestOfList className={BlogStyle["bestof-mobile"]} />
      </section>

        {/* Map section (Google Maps embed without API) */}
        <div className={BlogStyle["hr"]} />
        <section className={BlogStyle["map-wrap"]} aria-label="Map of Ontario winter farms">
          {/* Crop the My Maps header by shifting the iframe up inside a clipped container */}
          <div className={BlogStyle["map-clip"]}>
            <iframe 
              className={BlogStyle["map-frame"]}
              title="Google Map — Ontario winter farms"
              src="https://www.google.com/maps/d/embed?mid=1R_cXg90Jl5HacnWwyIwM9GF-Bg8K-rM&ehbc=2E312F" 
              loading="lazy"
            />
          </div>
        </section>


      {/* Bottom share/ad area */}
      {/* <div className={BlogStyle["hr"]} />
      <div className={BlogStyle["ad-box"]} role="complementary" aria-label="Advertisement">
        <img className={`${BlogStyle["ad-media"]} ${BlogStyle["ad-media-fixed"]}`} src={AD04} alt="Advertisement" />
      </div> */}

      {/* blog section */}
      <section className={`${AppStyle["section"]} ${AppStyle["card-section"]}`}>
        <WPPostsPage />
      </section>
    </article>
  );
}
